import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { LifeBuoy } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

const ReportIssueDialog = () => {
  const [open, setOpen] = useState(false);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!subject.trim() || !message.trim()) {
      toast.error('Please add a subject and description');
      return;
    }
    setBusy(true);
    try {
      await axios.post(`${API}/support-tickets`, { subject, message });
      toast.success('Issue reported — our team will look into it');
      setOpen(false); setSubject(''); setMessage('');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not submit issue');
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button
        variant="ghost" size="sm"
        onClick={() => setOpen(true)}
        className="hidden sm:flex items-center space-x-2 text-gray-600 hover:text-amber-600"
        title="Report a technical issue"
        data-testid="report-issue-btn"
      >
        <LifeBuoy className="h-4 w-4" />
        <span className="hidden lg:inline">Report Issue</span>
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="report-issue-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><LifeBuoy className="h-5 w-5 text-amber-600" /> Report a technical issue</DialogTitle>
            <DialogDescription>Describe what went wrong. Your shelter and account details are attached automatically.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <Input placeholder="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} data-testid="report-issue-subject" />
            <Textarea rows={5} placeholder="What happened? What were you trying to do?" value={message} onChange={(e) => setMessage(e.target.value)} data-testid="report-issue-message" />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={submit} disabled={busy} className="bg-amber-600 hover:bg-amber-700" data-testid="report-issue-submit">Send report</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ReportIssueDialog;
